/**
 * @generated SignedSource<<2519e6396ce7742db20defebea937dab>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type NavigationBarQuery$variables = {};
export type NavigationBarQuery$data = {
  readonly music_viewer: {
    readonly pieces_count: number;
  };
};
export type NavigationBarQuery = {
  variables: NavigationBarQuery$variables;
  response: NavigationBarQuery$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "MusicViewer",
    "kind": "LinkedField",
    "name": "music_viewer",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "pieces_count",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "NavigationBarQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "NavigationBarQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "84915d69a122c95e4a173eef256bc463",
    "id": null,
    "metadata": {},
    "name": "NavigationBarQuery",
    "operationKind": "query",
    "text": "query NavigationBarQuery {\n  music_viewer {\n    pieces_count\n  }\n}\n"
  }
};
})();

(node as any).hash = "771a53ae08387280f1113348e34752c5";

export default node;
